import React from 'react';

import { openDialog } from 'src/services/jira';
import { getLinkedIncident, useLinkedIncident } from 'src/services/linkedIncident';
import { useSession } from 'src/services/session';

import { locationReload } from 'src/lib/history';

import MenuDropdown from 'src/views/components/MenuDropdown';

const openDialogAction = (url, options = {}) => {
  const { incident: { id, incident_number, title } } = getLinkedIncident();
  openDialog(`${url}/?incidentId=${id}&incidentNumber=${incident_number}&incidentTitle=${encodeURI(title)}`, {
    width: '40vw',
    minHeight: 300,
    onClose: () => {
      locationReload();
    },
    ...options,
  });
};

const acknowledge = () => openDialogAction('/integration-jira-ui/issue_sidebar/modal_acknowledge_incident', { minHeight: 150 });
const resolve = () => openDialogAction('/integration-jira-ui/issue_sidebar/modal_resolve_incident');
const addNote = () => openDialogAction('/integration-jira-ui/issue_sidebar/modal_add_note');
const runIncidentWorkflow = () => openDialogAction('/integration-jira-ui/issue_sidebar/modal_run_incident_workflow', { minHeight: 500 });
const unlink = () => openDialogAction('/integration-jira-ui/issue_sidebar/modal_unlink_incident');
const reassign = () => openDialogAction('/integration-jira-ui/issue_sidebar/modal_reassign_incident', { minHeight: 500 });
const addResponders = () => openDialogAction('/integration-jira-ui/issue_sidebar/modal_add_responders', { minHeight: 500 });
const changePriority = () => openDialogAction('/integration-jira-ui/issue_sidebar/modal_change_priority');


const Actions = () => {
  const linkedIncident = useLinkedIncident();
  const { loggedIn, accountDomain } = useSession();

  if (!loggedIn || !linkedIncident.incident || linkedIncident.incidentAccountDomain !== accountDomain) return false;

  const { incident: { status } } = linkedIncident;
  const isResolved = status === 'resolved';

  return (
    <MenuDropdown
      analyticsEvent="sidebar_incidentresponse_actions"
      title="Actions"
      items={[
        {
          name: 'Acknowledge',
          key: 'acknowledge',
          action: acknowledge,
          disabled: isResolved
        },
        {
          name: 'Resolve',
          key: 'resolve',
          action: resolve,
          disabled: isResolved
        },
        {
          name: 'Add Note',
          key: 'add_note',
          action: addNote
        },
        {
          name: 'Run Workflow',
          key: 'run_workflow',
          action: runIncidentWorkflow,
        },
        {
          name: 'Reassign/Delegate/Escalate',
          key: 'reassign',
          action: reassign
        },
        {
          name: 'Unlink incident',
          key: 'unlink',
          action: unlink
        },
        {
          name: 'Add Responders',
          key: 'add_responders',
          action: addResponders,
        },
        {
          name: 'Change Priority',
          key: 'change_priority',
          action: changePriority,
        },
      ]}
    />
  );
};

export default Actions;
